var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule"},[_c('div',{staticClass:"rule-con"},[_c('div',{staticClass:"rule-text"},[_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.ruleText)}})])]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.close}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-077b7f9b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ruleAlert.vue
// module id = null
// module chunks = 